import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

const teachers = [
    // {
    //     // name: "Dr. Sasidhar Gumma",
    //     // namelink:"https://iittp.ac.in/dr-sasidhar-gumma",
    //     // position1: "Professor",
    //     // position2: "Dean - Academic Affairs",
    //     // phoneno:"0877 250 3671",
    //     // email: "dean_aa@iittp.ac.in",
    //     // image: "https://files.iittp.ac.in/images/demo/iit/SG.jpg"

    //     // social: [
    //     //     { platform: "facebook", link: "#" },
    //     //     { platform: "instagram", link: "#" },
    //     //     { platform: "twitter", link: "#" }
    //     // ]
    // },
    {
        name: "Prof. Rama Krishna Sai Gorthi",
        namelink: "https://iittp.ac.in/dr-sasidhar-gumma",
        position1: "Professor",
        position2: "Dean - Academic Affairs",
        phoneno: "0877 250 3671",
        email: "dean_aa@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/SubramanyamSai.JPG"
    },
    {
        name: "Prof. Thamida Sunil Kumar",
        namelink: "https://iittp.ac.in/dr-anki-reddy-katha",
        position1: "Professor ",
        position2: "Advisor - Research",
        phoneno: "9492079213",
        email: "aaa_research@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Thamida_sunil_kumar_2019.jpg"
    },
    {
        name: "Dr. Durga Prasad Challa",
        namelink: "https://iittp.ac.in/dr-durga-prasad-challa",
        position1: "Associate Professor",
        position2: "Chairperson - Admissions",        
        phoneno: "0877 250 3355",
        email: " chair_admissions@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/durga1.jpg"
    },   
    {
        name: "Dr. Madan Mohan Avulapati",
        namelink: "https://iittp.ac.in/dr-madan-mohan-avulapati",
        position1: "Associate Professor",
        position2: "Advisor - Courses",
        phoneno: "0877 250 3359",
        email: "aaa_courses@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/madan_new.jpg"
    },

    

 
    {
        name: "Mr. Harikrishna Reddy",
        namelink: "#",
        position1: "Assistant Registrar",
        position2: "Areas of Responsibility : Matters related to MS/PhD scholars, Fee, Stipend, Scholarships, Refunds, Academic Events.",
        phoneno: "0877 250 3530",
        email: "ar_research@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/HariKrishnaReddy.jpg"
    },

    {
        name: "Mr. Madhu N",
        namelink: "#",
        position1: "Assistant Registrar",
        position2: "Areas of Responsibility : Admissions, Academic Courses, Grades, ERP, Guest Faculty, RTI, BAP & Senate. ",
        phoneno: "0877 250 3508",
        email: "ar_aa@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/madhun.png"
    },

    {
        name: "Smt Y Sandhya",
        namelink: "#",
        position1: "Section Officer",
        position2: "Areas of Responsibility : Matters related to MS/PhD scholars.  ",
        phoneno: "0877 250 3531 ",
        email: "research@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/sandhya.jpg"
    },

    {
        name: "Mr. K Prasad Rao",
        namelink: "#",
        position1: "Junior Superintendent ",
        position2: "Areas of Responsibility : Courses, Grades, ERP, Guest Faculty, BAP & Senate.",
        phoneno: "0877 250 3531",
        email: "academics@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/PRASAD RAO K.jpg"
    },

    // {
    //     name: "Mr. Srinivasulu K V",
    //     namelink: "#",
    //     position1: "Junior Superintendent ",
    //     position2: "Areas of Responsibility:",
    //     phoneno: "0877 250 XXXX",
    //     email: "academics@iittp.ac.in",
    //     image: "https://files.iittp.ac.in/images/demo/iit/Staff/KVS.jpg"
    // },


    {
        name: "Mr. Mohammad Ishaq Alikhan",
        namelink: "#",
        position1: "Junior Superintendent ",
        position2: "Areas of Responsibility : Admissions, Statistics and Reports",
        phoneno: "0877 250 3532",
        email: "admissions@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ishaq_2.jpg",
    },


    {
        name: "Mr. Sagar",
        namelink: "#",
        position1: "Junior Assistant ",
        position2: "Areas of Responsibility : Fee, Stipend, Scholarships, Refunds, Academic Events ",
        phoneno: "0877 250 3532",
        email: "academics@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vidyasagar.jpg",
    },

   
    {
        name: "Mr. KVS Roshan Kishore",
        namelink: "#",
        position1: "Junior Assistant ",
        position2: "Areas of Responsibility :",
        phoneno: " ",
        email: "academics@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/KVS_Roshan%20Kishore_JA.jpg",
    },


    {
        name: "Ms. Basila Ali",
        namelink: "#",
        position1: "Junior Assistant ",
        position2: "Areas of Responsibility :",
        phoneno: " ",
        email: "academics@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/Basila_Ali_JA.png",
    },

    {
        name: "Mr. Ganjikunta Balaji Kiran",
        namelink: "#",
        position1: "Junior Assistant ",
        position2: "Areas of Responsibility :",
        phoneno: " ",
        email: "academics@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ganjikunta_balaji kiran_JA.jpg",
    },




    
]

function Main() {
    return (
        <>
            <Header/>
            <Breadcrumb title="Home" subtitle="Academic Team"/>
            <section className="team-area fix p-relative pt-120 pb-80">
                {/*   */}
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> Our Team
                                </h5>
                                <h2>ACADEMIC TEAM</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {teachers.map((teacher, index) => (
                           <div key={index} className="col-xl-3 col-md-6 col-sm-6">
                                <div className="single-team mb-40">
                                    <div className="team-thumb">
                                        <div className="brd">
                                            <Link to="/team-single">
                                                <img src={teacher.image} alt="img" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <h4>
                                            <Link to={teacher.namelink}>{teacher.name}</Link>
                                        </h4>
                                        <div className="text-dark">
                                        <p className='fw-bold' >{teacher.position1}</p>
                                            <p className="text-dark fw-bold">{teacher.position2}</p>
                                            <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{teacher.phoneno}</p>
                                            {/* <p className="text-orange"><i className="fal fa-envelope  me-2"></i> <Link to={teacher.email} target="_blank" className="btn btn-primary">{teacher.email}</Link></p> */}
                                            <p className="text-dark"><i className="fal fa-envelope  me-2"></i>{teacher.email}</p>
                                        </div>
                                        <div className="team-social">
                                            {/* <ul>
                                                {teacher.social.map((platform, index) => (
                                                    <li key={index}>
                                                        <Link to={platform.link}>
                                                            {platform.platform === 'facebook' && <i className="fab fa-facebook-f" />}
                                                            {platform.platform === 'instagram' && <i className="fab fa-instagram" />}
                                                            {platform.platform === 'twitter' && <i className="fab fa-twitter" />}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Main